import React from 'react';

function CheckIcon(props: any): JSX.Element {
  return (
    <svg width='20' height='15' viewBox='0 0 20 15' fill='none' {...props}>
      <path d='M0 7.79466L3.95734 3.96155L7.52152 7.71155L17.1296 0L20 2.8232L7.43415 15L0 7.79466Z' fill='#4CA667' />
    </svg>
  );
}

export default CheckIcon;
